import * as React from 'react';
import FullComposeForm from './FullComposeForm';
import { observer } from 'mobx-react-lite';

export interface ProjectionCalendarComposeProps {
    formId: string;
}

const ProjectionCalendarCompose: React.FunctionComponent<ProjectionCalendarComposeProps> = props => {
    return <FullComposeForm formId={props.formId} />;
};

export default observer(ProjectionCalendarCompose);
